import React from "react";
import styled from "styled-components";

const Title = styled.h1`
  font-size: 30px;
  color: ${({ theme }): string => theme.colors.yellow};
  margin: 0;
  font-weight: 400;
  white-space: nowrap;
  overflow: visible;
  text-overflow: unset;
  width: 100%;
  font-size: clamp(20px, 3.5vw, 60px);
  transition: font-size 0.4s ease;
`;
const PageTitle = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element => {
  return <Title>{children}</Title>;
};

export default PageTitle;
